if (!customElements.get('card-slider')) {
  class CardSlider extends HTMLElement {
    constructor() {
      super();

      const swiperOptions = JSON.parse(this.getAttribute('data-swiper-options')) || {};
      this.initSlider(swiperOptions);

      if (this.classList.contains('js-testimonials')) {
        window.addEventListener('resize', () => {
          const isMobile = window.innerWidth < 750;
          const isSlideEffect = this.slider.params.effect === 'slide';

          if ((isMobile && !isSlideEffect) || (!isMobile && isSlideEffect)) {
            this.reInitSlider(swiperOptions);
          }
        });
      }
    }

    reInitSlider(swiperOptions) {
      if (this.slider) {
        this.slider.destroy(true, true); // Asegurarse de destruir correctamente
      }
      this.initSlider(swiperOptions);
    }

    initSlider(swiperOptions) {
      const sliderOptions = {
        slidesPerView: 2, // Muestra 4 productos
        spaceBetween: swiperOptions.spaceBetweenMobile || 8, // Espacio entre productos en móviles
        resistanceRatio: 0.72,
        autoplay: {
          delay: 3000, // 3 segundos
          disableOnInteraction: false, // No desactiva autoplay al interactuar
        },
        breakpoints: {
          480: {
            slidesPerView: 2, // 2 productos en pantallas pequeñas
            spaceBetween: swiperOptions.spaceBetweenMobile || 8,
          },
          750: {
            slidesPerView: 7, // 5 productos en pantallas medianas
            spaceBetween: swiperOptions.spaceBetweenDesktop || 16,
          },
        },
      };

      // Inicializamos el Swiper y lo asignamos a `this.slider`
      this.slider = new Swiper(this, sliderOptions);
    }
  }

  customElements.define('card-slider', CardSlider);
}

